/** Generic coloured status pill. Reused across admin tables (M2A → M6). */
const TONES = {
  green:  "bg-brand-success/10 text-brand-success border border-brand-success/25",
  amber:  "bg-amber-100 text-amber-900 border border-amber-200",
  red:    "bg-red-100 text-red-800 border border-red-200",
  grey:   "bg-gray-100 text-gray-700 border border-gray-200",
  blue:   "bg-sky-100 text-sky-800 border border-sky-200",
};

export default function StatusBadge({ tone = "grey", label, testId }) {
  const cls = TONES[tone] || TONES.grey;
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 text-xs font-medium tracking-wide uppercase ${cls}`}>
      {label}
    </span>
  );
}
